export * from './Component_NLPRequestTemplates.js';
//# sourceMappingURL=index.js.map